import type { ResultadoImportacao } from "../../../services/clientesFornecedor"

export interface ImportacaoClientesModel {
    conteudo: string
    resultado: ResultadoImportacao | null
}

export const ImportacaoClientesInicial: ImportacaoClientesModel = {
    conteudo: "",
    resultado: null,
}
